import type { Message } from '../models';

export function hasActiveConversation(messages: Message[], isLoading: boolean): boolean {
  return messages.length > 0 || isLoading;
}
